export default __webpack_public_path__ + "static/grand_hotel_3-491a53449d2da4fa1f4cb8351dfd733c.webp";